@if (content) {
<footer class="bg-col-1 _footer"
        [bottomPanelArea]="'footer'">
    <div class="wrap p-t-10 p-t-4-s p-t-4-m p-b-10 p-b-5-s p-b-5-m flex flex-column-s flex-column-m _menus">
        <a [routerLink]="'/'"
           class="block m-b-4-s m-b-2-m">
            <img [width]="client.isS || client.isM ? 240 : 273"
                 [height]="client.isS || client.isM ? 90 : 103"
                 [dfImage]="content.logo"
                 alt="Acoustical Solutions">
        </a>
        @for (menu of content.menus; track $index) {
        <div *ifSize="'XL'"
             class="inline-block _menu-item"
             [ngClass]="menu.type =='description' ? 'b-l b-col-11 p-l-8 flex-span-1' : ''">
            <h3 class="h3 col-w"
                *iCms="'heading' of menu"></h3>
            @if(menu.type === 'link'){
            <ng-container *ngTemplateOutlet="linksMenuTemplate; context: { $implicit: menu }" />
            }@else {
            <ng-container *ngTemplateOutlet="descriptionMenuTemplate; context: { $implicit: menu }" />
            }
        </div>
        <div *ifSize="'MS'">
            <button class="w-12 flex flex-middle flex-justify-between b-t b-col-11 p-t-5 p-b-5 col-w"
                    (click)="toggleService.toggle(['footer-menus', $index])">
                <span class="s1"
                      *iCms="'heading' of menu"></span>
                <i class="_hide-up-icon"
                   [toggleClass]="'!icon-plus icon-minus'"
                   [toggleClassBy]="toggleService.getState(['footer-menus', $index])"></i>
            </button>
            <hide-up class="block"
                     [open]="toggleService.getState(['footer-menus', $index])">
                @if(menu.type === 'link'){
                <ng-container *ngTemplateOutlet="linksMenuTemplate; context: { $implicit: menu }" />
                }@else {
                <ng-container *ngTemplateOutlet="descriptionMenuTemplate; context: { $implicit: menu }" />
                }
            </hide-up>
        </div>
        }
    </div>
    <!-- footer bottom -->
    <div class="bg-col-52 p-t-4-x p-t-4-l p-b-4-x p-b-4-l">
        <div class="wrap flex flex-middle flex-justify-between flex-column-s flex-column-m">
            <ul
                class="flex-span-1 flex flex-middle flex-justify-center-s flex-justify-center-m p-t-2-s p-t-2-m p-b-2-s p-b-2-m">
                @for(method of content.paymentMethods; track method) {
                <li class="inline-flex"
                    [ngClass]="!$first ? 'm-l-3 m-l-1-s m-l-1-m' : ''">
                    <img [dfImage]="method.icon"
                         [alt]="method.name || ''"
                         [height]="24"
                         [width]="36">
                </li>
                }
            </ul>
            @if(content.bottomImage){
            <div class="p-t-2-s p-t-2-m p-b-2-s p-b-2-m">
                <img class="m-a-1"
                     [width]="160"
                     [height]="30"
                     [dfImage]="content.bottomImage"
                     alt="">
            </div>
            }
            <!-- links -->
            <ul
                class="flex-span-1 flex-l flex-x flex-middle flex-justify-end center-s center-m p-t-1-s p-t-1-m p-b-1-s p-b-1-m">
                @for (item of content.bottomLinks; track $index) {
                <li class="inline-block c1 col-11 m-l-0-s m-l-0-m"
                    [class.m-l]="!$first">
                    @if($odd && (client.isS || client.isM)){
                    &nbsp;|
                    }
                    <href [link]="item.url">
                        <span *iCms="'text' of item">
                        </span>
                    </href>
                </li>
                @if($odd && (client.isS || client.isM)) {
                <!-- purely presentational line break; display:contents keeps the
                     <br> behaving exactly as a direct child would while keeping
                     the <ul> to <li>-only children -->
                <li style="display: contents"
                    aria-hidden="true">
                    <br>
                </li>
                }
                }
            </ul>
        </div>
    </div>
</footer>

<!-- ------- TEMPLATES ----------- -->
<ng-template #linksMenuTemplate
             let-menu>
    <ul class="m-t-4-l m-t-4-x m-b-5-s m-b-5-m">
        @for (item of menu.items; track $index) {
        <li class="m-t-2-x m-t-2-l"
            [ngClass]="!$first ? 'm-t-4-s m-t-4-m' : ''">
            <href [link]="item.url"
                  class="inline-block _menu-link p1 col-4 s2-s s2-m col-w-s col-w-m">
                <span *iCms="'title' of item"></span>
            </href>
        </li>
        }
    </ul>
</ng-template>

<ng-template #descriptionMenuTemplate
             let-menu>
    <ul class="m-t-4-l m-t-4-x m-b-4-l m-b-4-x">
        <li>
            <a href="tel:+18007825472">800-782-5472</a>
        </li>
        @for (item of menu.items; track $index) {
        <li class="p-t-2 p-b-2 p-l p-r b-a b-col-11 col-w _menu-link-with-description"
            [class.m-t-1]="!$first">
            <href [link]="item.url"
                  [hrefClass]="'pos-relative block'">
                <span class="block p-r-9">
                    <span class="p1 block"
                          *iCms="'title' of item"></span>
                    <span class="c1 col-51 m-t-1 block"
                          *iCms="'description' of item"></span>
                </span>
                <i class="_menu-item-icon"
                   [ngClass]="item.icon"></i>
            </href>
        </li>
        }
    </ul>
</ng-template>
}